import script from "./KAMA.vue?vue&type=script&lang=js"
export * from "./KAMA.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__